import { apiClient } from '@/core/api/apiClient'

const extractTransferResult = (
  result: unknown,
): { transferred: boolean; storagePath?: string } => {
  const data =
    (result as { data?: { transferred?: boolean; storagePath?: string } })?.data ?? result
  const payload = data as { transferred?: boolean; storagePath?: string }
  return {
    transferred: payload.transferred === true,
    storagePath: payload.storagePath,
  }
}

/** Copies a contact's driver's license photo onto the linked client user account. */
export const transferContactDriverLicenseToUser = async (
  contactId: string,
  clientUserId: string,
): Promise<{ transferred: boolean; storagePath?: string }> => {
  const result = await apiClient.portal.admin.transferContactDriverLicenseToUser(
    contactId,
    clientUserId,
  )
  return extractTransferResult(result)
}
